import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { injectIntl, defineMessages } from 'react-intl';

import Icon from '../../../components/Icon';
import List from '../../../components/List';
import Label from '../../../components/Label';

const messages = defineMessages({
  transferWebsite: {
    id: 'hubs.transfer.overview.important-links.website',
    defaultMessage: 'Transfer Student Website',
  },
  transferSupport: {
    id: 'hubs.transfer.overview.important-links.support',
    defaultMessage: `Transfer Support Services`,
  },
  transferFinancialAid: {
    id: 'hubs.transfer.overview.important-links.financial-aid',
    defaultMessage: `Financial Aid Information`,
  },
  transferCreditInfo: {
    id: 'hubs.transfer.overview.important-links.credit-info',
    defaultMessage: `Credit Transfer Information`,
  },
});

function ExternalLink({ url, text }) {
  return (
    <Label
      as="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="external-link"
    >
      <Icon name="external" />
      {text}
    </Label>
  );
}

ExternalLink.propTypes = {
  url: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

function ImportantCollegeLinks({
  intl,
  restricted = false,
  infoUrl,
  supportUrl,
  financialAidUrl,
  creditInfoUrl,
}) {
  return (
    <List
      relaxed
      className={classNames({ 'important-college-links': true, restricted: restricted })}
    >
      {infoUrl && (
        <List.Item>
          <ExternalLink
            url={infoUrl}
            text={intl.formatMessage(messages.transferWebsite)}
          />
        </List.Item>
      )}
      {supportUrl && (
        <List.Item>
          <ExternalLink
            url={supportUrl}
            text={intl.formatMessage(messages.transferSupport)}
          />
        </List.Item>
      )}
      {financialAidUrl && (
        <List.Item>
          <ExternalLink
            url={financialAidUrl}
            text={intl.formatMessage(messages.transferFinancialAid)}
          />
        </List.Item>
      )}
      {creditInfoUrl && (
        <List.Item>
          <ExternalLink
            url={creditInfoUrl}
            text={intl.formatMessage(messages.transferCreditInfo)}
          />
        </List.Item>
      )}
    </List>
  );
}

ImportantCollegeLinks.propTypes = {
  intl: PropTypes.object,
  restricted: PropTypes.bool,
  infoUrl: PropTypes.string,
  supportUrl: PropTypes.string,
  financialAidUrl: PropTypes.string,
  creditInfoUrl: PropTypes.string,
};

export default injectIntl(ImportantCollegeLinks);
